import React from 'react';
import Link from 'next/link';
import { Article } from '@/types/Blog';

interface FeaturedEventProps {
  featuredArticle: Article;
}

const FeaturedEvent: React.FC<FeaturedEventProps> = ({ featuredArticle }) => {
  const shortDesc = featuredArticle.shortDescription.split(' ').slice(0, 35).join(' ');

  return (
    <div className='rounded-md bg-white relative'>

      <h2 className="text-2xl font-semibold p-5 py-3 bg-red rounded-t-md ">Event Terkini</h2>
      <div className='overflow-hidden'>
        <div className='relative h-52 md:h-96 overflow-hidden'>
          <div className='w-full h-52 md:h-96 hover:scale-[1.025] transition-all duration-700 absolute top-0 left-0'>
            <img
              src={featuredArticle.image}
              alt={featuredArticle.title}
              className="w-full h-52 md:h-96 object-cover"
            />
            <div className='w-full h-52 md:h-96 bg-gradient-to-t from-gray-900 via-transparent to-transparent absolute top-0 left-0' />

          </div>
          <div className='absolute text-white bottom-0 left-0 p-5 py-2 md:py-5'>
            <span className="text-base md:text-xl">{featuredArticle.time} | {featuredArticle.date}</span>
            <h3 className="font-bold text-lg md:text-4xl line-clamp-2">
              <Link href={`/iit-news/${featuredArticle.slug}`}>
                {featuredArticle.title}
              </Link>
            </h3>
          </div>
        </div>


        <div className='p-5'>

          <p className="mb-3 text-justify">
            {shortDesc} (...)
          </p>
          <Link
            href={`/iit-news/${featuredArticle.slug}`}
            className="mt-2 bg-defaultBlue text-white px-5 py-2 rounded font-semibold inline-block"
          >
            Baca Selengkapnya
          </Link>

        </div>
      </div>
    </div>
  );
};

export default FeaturedEvent;